import { render, staticRenderFns } from "./CRAddressSelectorV2.vue?vue&type=template&id=8b8ed028&scoped=true"
import script from "./CRAddressSelectorV2.vue?vue&type=script&lang=js"
export * from "./CRAddressSelectorV2.vue?vue&type=script&lang=js"
import style0 from "./CRAddressSelectorV2.vue?vue&type=style&index=0&id=8b8ed028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8ed028",
  null
  
)

export default component.exports